import iCSAllClaims from './CSAllClaims';
import { statusFilterSel } from 'src/store/modules/ClaimStatus';
import { connect } from 'react-redux';

import iObjCSService from 'src/services/claimStatus/claimStatusService';

interface IDispatchFromProps {
  getClaimTypes(): void;
}

const mapStateToProps = (state: any) => ({
  statusFilter: statusFilterSel(state)
});

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  getClaimTypes: () => dispatch(iObjCSService.gClaimTypeLookupData())
});

export default connect(mapStateToProps, mapDispatchToProps)(iCSAllClaims);
